import React from 'react';
import { captureBusinessException, reportRenderDegraded } from '@/monitoring';

type ErrorBoundaryProps = {
  children: JSX.Element;
};

type ErrorBoundaryState = {
  hasError: boolean;
};

const getRootStatus = (): {
  hasRoot: boolean;
  rootChildCount: number;
  rootTextLength: number;
} => {
  const root = document.getElementById('root');

  return {
    hasRoot: Boolean(root),
    rootChildCount: root?.children?.length ?? 0,
    rootTextLength: root?.textContent?.length ?? 0
  };
};

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  public state: ErrorBoundaryState = {
    hasError: false
  };

  public static getDerivedStateFromError(): ErrorBoundaryState {
    return {
      hasError: true
    };
  }

  public componentDidCatch(error: Error, _errorInfo: React.ErrorInfo): void {
    const rootStatus = getRootStatus();
    reportRenderDegraded({
      error,
      ...rootStatus
    });
    captureBusinessException(error, 'error_boundary');
  }

  public render(): JSX.Element | null {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
